import type { ComponentProps } from "react";

import { SignatureField } from "./SignatureField";
import { SignatureSkeleton } from "./SignatureSkeleton";

type NoteSignatureProps = ComponentProps<typeof SignatureField> & {
  isLoading?: boolean;
};

export function NoteSignature({ children, isLoading, label, ...rest }: NoteSignatureProps) {
  if (isLoading) return <SignatureSkeleton />;

  return (
    <SignatureField label={label} {...rest}>
      {children}
    </SignatureField>
  );
}
